export default class FulltextSearcher {
	constructor() {
		this.init();
	}

	init() {
		document.querySelectorAll('input[type="text"][data-provide="fulltextSearcher"]:not([data-fts-init="1"])').forEach(function (item, key) {
			item.setAttribute('data-fts-init', "1");
			let keyInItems = item.getAttribute('data-fts-key');

			item.addEventListener('keyup', (e) => {
				let searchVal = item.value.toLowerCase();

				document.querySelectorAll('*[data-provide="fulltextSearcherItem"][data-fts-key="' + keyInItems + '"]').forEach(function (searchItem, key) {
					if (searchItem.getAttribute('data-fts-search').toLowerCase().indexOf(searchVal) >= 0 || searchVal === '') {
						searchItem.style.removeProperty('display');
					} else {
						searchItem.style.display = 'none';
					}
				});
			});
		});
	}
}
